import type { OwnedClassCard, ProfilePostItem, UserProfile } from '@/features/profile/types';

export const MOCK_CURRENT_USER_PROFILE: UserProfile = {
  id: 'user-nasri',
  name: 'Nasri Marco',
  username: 'N_Marco',
  email: 'nasri.marco@myu.edu',
  accountType: 'instructor',
  accountTypeLabel: 'Instructor',
  institution: 'MyU English School',
  initials: 'NM',
  verified: true,
  stats: {
    posts: 29,
    following: 0,
    followers: 5,
    joinedClasses: 0,
  },
};

export const MOCK_OWNED_CLASSES: readonly OwnedClassCard[] = [
  {
    id: 'class-math101',
    code: 'MATH101',
    name: 'Math 101',
    postCount: 0,
    memberCount: 1,
    isPrivate: false,
    dotClassName: 'bg-[#60a5fa]',
  },
  {
    id: 'class-math10a',
    code: 'MATH10A',
    name: 'Math 10 A',
    postCount: 18,
    memberCount: 46,
    isPrivate: true,
    dotClassName: 'bg-[#fb923c]',
  },
  {
    id: 'class-math11a',
    code: 'MATH11A',
    name: 'Math 11 A',
    postCount: 12,
    memberCount: 38,
    isPrivate: true,
    dotClassName: 'bg-[#34d399]',
  },
  {
    id: 'class-math10b',
    code: 'MATH10B',
    name: 'Math 10 B',
    postCount: 8,
    memberCount: 42,
    isPrivate: true,
    dotClassName: 'bg-[#a78bfa]',
  },
] as const;

export const MOCK_PROFILE_POSTS: readonly ProfilePostItem[] = [
  {
    id: 1001,
    isOwnPost: true,
    author: {
      name: 'Nasri Marco',
      avatar: '',
      initials: 'NM',
      verified: true,
      username: 'N_Marco',
    },
    timestamp: '05 Mar 2026',
    content: 'Refer the document',
    media: {
      type: 'documents',
      items: [],
      documents: [{ name: 'Assignment Brief_1222.docx', type: 'word' }],
    },
    stats: { likes: 1, comments: 1, impressions: 23 },
  },
  {
    id: 1002,
    isOwnPost: true,
    author: {
      name: 'Nasri Marco',
      avatar: '',
      initials: 'NM',
      verified: true,
      username: 'N_Marco',
    },
    timestamp: '28 Feb 2026',
    audience: { scope: 'class', className: 'Math 10 A' },
    content:
      'Reminder: please review the assignment brief before our next session. Feel free to ask questions in the class discussion.',
    stats: { likes: 3, comments: 0, impressions: 41 },
  },
] as const;
